/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_Q_Change_RoundsInputs */



/**
* | output |
* | --- |
* | "Can I change the number of rounds mid-tournament?" |
*
* @param {Og_Faq_Q_Change_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_q_change_rounds = /** @type {((inputs?: Og_Faq_Q_Change_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_Q_Change_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Puis-je modifier le nombre de rondes en cours de tournoi ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Puedo cambiar el número de rondas durante el torneo?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Posso alterar o número de rodadas durante o torneio?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posso cambiare il numero di round durante il torneo?")
	return /** @type {LocalizedString} */ ("Can I change the number of rounds mid-tournament?")
});